import React from "react";
import cx from "classnames";
import styles from "./promptSuggestions.module.scss";

interface PromptSuggestionsProps {
  onSelect: (type: string) => void;  
}

const PromptSuggestions: React.FC<PromptSuggestionsProps> = ({ onSelect }) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>
        <div className={styles.promptbox}>
          <i className={cx(styles.bulb, 'paperflite-bulb')} />
          <span> quick prompts :</span>
        </div>
      </span>

      <button className={styles.pill} onClick={() => onSelect("article")}>
        <i className={cx(styles.icon, styles.sparkle, 'paperflite-document')} />
        <span>article</span>
      </button>

      <div className={styles.pipeDivider} />

      <button className={styles.pill} onClick={() => onSelect("podcast")}>
        <i className={cx(styles.icon, styles.mic, styles.sparkle, 'paperflite-mic')} />
        <span>podcast</span>
      </button>
    </div>
  );
};

export default PromptSuggestions;